"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notification = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var ButtonAction_1 = require("../ButtonAction");
var Icon_1 = require("../Icon");
var Notification = function (props) {
    var _a, _b, _c, _d;
    var animation = props.animation, children = props.children, className = props.className, heading = props.heading, isOpen = props.isOpen, link = props.link, linkVariant = props.linkVariant, notificationRef = props.notificationRef, trigger = props.trigger, triggerIcon = props.triggerIcon, triggerOnClick = props.triggerOnClick, type = props.type, withShadow = props.withShadow;
    var _e = React.useState(!isOpen), isComponentHidden = _e[0], setComponentHidden = _e[1];
    var _f = React.useState(isOpen), isComponentOpen = _f[0], setComponentOpen = _f[1];
    var headingRef = React.useRef(null);
    var paragraphRef = React.useRef(null);
    var iconSymbol;
    switch (type) {
        case 'alert':
            iconSymbol = 'Alert';
            break;
        case 'warning':
            iconSymbol = 'Warning';
            break;
        case 'info':
            iconSymbol = 'Info';
            break;
        case 'success':
            iconSymbol = 'Success';
            break;
        default:
            throw new Error('Use alert, warning, info or success type');
    }
    var iconScreenreader;
    switch (type) {
        case 'alert':
            iconScreenreader = 'Alert';
            break;
        case 'warning':
            iconScreenreader = 'Warning';
            break;
        case 'success':
            iconScreenreader = 'Success';
            break;
    }
    var iconSymbolName = iconSymbol && "message" + iconSymbol + "16";
    var classNames = "notification" + (animation ? ' animate' : '') + (isComponentOpen ? ' show' : '') + (isComponentHidden ? " d-none" : '') + (type ? " " + type : '') + (withShadow ? ' with-shadow' : '') + (className ? " " + className : '');
    React.useEffect(function () {
        if (isOpen) {
            setComponentHidden(false);
            setTimeout(function () {
                // open component
                setComponentOpen(true);
            }, 20);
        }
        else {
            setComponentOpen(false);
        }
    }, [isOpen]);
    React.useEffect(function () {
        var _a, _b;
        // move focus when Notification shows
        if (isOpen) {
            if (heading) {
                (_a = headingRef === null || headingRef === void 0 ? void 0 : headingRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
            else if (children && typeof children === 'string' && !heading) {
                (_b = paragraphRef === null || paragraphRef === void 0 ? void 0 : paragraphRef.current) === null || _b === void 0 ? void 0 : _b.focus();
            }
        }
    }, [isOpen, heading, children]);
    var transitionEnd = function () {
        if (isComponentOpen) {
            setComponentHidden(false);
        }
        else {
            setComponentHidden(true);
        }
    };
    return (React.createElement("div", { className: classNames, onAnimationEnd: transitionEnd, ref: notificationRef, role: "region", "aria-label": "notification" },
        iconSymbolName &&
            React.createElement(Icon_1.Icon, __assign({}, (iconScreenreader && { screenreader: iconScreenreader }), { symbol: iconSymbolName, type: "svginline" })),
        React.createElement("div", { className: "notification-body" },
            heading && React.createElement("h4", { tabIndex: -1, ref: headingRef, className: "h4" }, heading),
            children && typeof children === 'string' &&
                React.createElement("p", __assign({}, (!heading && { tabIndex: -1, ref: paragraphRef })), children),
            children && typeof children !== 'string' && children,
            link && linkVariant !== 'hyperlink' &&
                React.createElement(ButtonAction_1.ButtonAction, { variant: linkVariant ? linkVariant : 'subtle', id: link === null || link === void 0 ? void 0 : link.controlId, href: (_a = link === null || link === void 0 ? void 0 : link.link) === null || _a === void 0 ? void 0 : _a.url, target: (_b = link === null || link === void 0 ? void 0 : link.link) === null || _b === void 0 ? void 0 : _b.target }, link === null || link === void 0 ? void 0 : link.displayText),
            link && linkVariant === 'hyperlink' &&
                React.createElement("a", { className: "notification-hyperlink", id: link === null || link === void 0 ? void 0 : link.controlId, href: (_c = link === null || link === void 0 ? void 0 : link.link) === null || _c === void 0 ? void 0 : _c.url, target: (_d = link === null || link === void 0 ? void 0 : link.link) === null || _d === void 0 ? void 0 : _d.target }, link === null || link === void 0 ? void 0 : link.displayText)),
        trigger &&
            React.createElement(ButtonAction_1.ButtonActionSubtle, { id: (trigger === null || trigger === void 0 ? void 0 : trigger.controlId) || 'notification-close', onClick: triggerOnClick }, triggerIcon &&
                React.createElement(Icon_1.Icon, { screenreader: "Close", symbol: triggerIcon, type: "svginline" }))));
};
exports.Notification = Notification;
exports.Notification.defaultProps = {
    animation: true,
    triggerIcon: 'controlClose24',
};
exports.Notification.propTypes = {
    animation: PropTypes.bool,
    children: PropTypes.any,
    heading: PropTypes.string,
    link: PropTypes.object,
    linkVariant: PropTypes.string,
    trigger: PropTypes.object,
    triggerIcon: PropTypes.string,
    triggerOnClick: PropTypes.func,
    type: PropTypes.string.isRequired,
    withShadow: PropTypes.bool,
};
